// src/pages/SSOJump.js

import React from 'react';

class SSOJump extends React.Component {
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');

        if (!token) {
            alert('Missing SSO token');
            return;
        }

        // Full browser redirect to OBS backend
        window.location.href = `https://auth.onboardsoft.com:3000/admin_obs/sso/jump?token=${encodeURIComponent(token)}`;
    }

    render() {
        return (
            <div style={{
                paddingTop: "60px",
                textAlign: "center",
                fontFamily: "'Helvetica Neue', 'Segoe UI', sans-serif",
                backgroundColor: "#f8f9fa",
                minHeight: "100vh",
                color: "#2c3e50"
            }}>
                <h2 style={{
                    fontSize: "22px",
                    fontWeight: 500,
                    marginBottom: 10
                }}>
                    Signing you in...
                </h2>

                <p style={{
                    fontSize: "15px",
                    color: "#7f8c8d",
                    marginBottom: "28px"
                }}>
                    Please wait while we log you in securely via SSO.
                </p>

                {/* Bootstrap Spinner */}
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden"></span>
                </div>
            </div>
        );
    }
}

export default SSOJump;
